import { useRouter } from 'next/router'

import urls from '@/config/urls'
import { userSettingsUrls } from '@/config/urls/userSettings'
import { PageMetadata } from '@/pages/_app'
import { useHttpFetcher } from '@/utils/http'

import { ApiResponse, User } from '@/types/index.d'

export function useAuth(pageMetaData?: PageMetadata): ApiResponse<User> {
  const router = useRouter()

  const url = pageMetaData?.isPublic ? null : userSettingsUrls.userInfo
  const { data, error, isLoading, mutate } = useHttpFetcher<User>({
    url,
    customSwrConfig: {
      shouldRetryOnError: false,
      revalidateOnFocus: true, // This is not actually working we added the same in useLoggedUser
    },
  })

  if ((data && !data.active) || error) {
    const pathname = router.asPath
    if (pathname.length > 1) {
      const params = new URLSearchParams({
        redirect_uri: pathname,
      })
      router.push(`${urls.auth.login}?${params.toString()}`)
    } else {
      router.push(urls.auth.login)
    }
  }

  return {
    data,
    error,
    isLoading,
    mutate,
  }
}
